export default __webpack_public_path__ + "static/media/choose-us-04.4135ec00.svg";